// Adapts a SelectMulti onChange payload (array of options) into the
// { value: true } map that the form/filter actions expect.
export function toSelectedMap(selected) {
  return Object.fromEntries(selected.map((option) => [option.value, true]));
}
